<template>
    <div id="pop-up-ads">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Pop Up Ads' },
            ]"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Pop Up Ads</h3>

        <v-card>
            <v-card-title>
                Daftar Pop Up Ads
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="createPopUpAds()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Pop Up Ads
                </v-btn>
            </v-card-title>

            <v-divider />

            <app-datatable
                :items="popUpAds"
                :headers="headers"
                :hasAction="true"
                :has-custom-pagination="false"
                :custom-pagination-total-items="popUpAds.length"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editPopUpAds()"
                v-on:changePage="pageNumber = $event"
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headers[$event.key] }
                "
            ></app-datatable>

            <app-spinner v-if="isLoading"></app-spinner>
        </v-card>
    </div>
</template>

<script>
import Moment from "moment";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import PopUpAdsService from "@/modules/pop_up_ads/services/pop_up_ads.js";

export default {
    name: "pop-up-ads",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            search: null,
            selectedRow: null,
            isLoading: false,
            popUpAds: [],
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "No.", value: "no" },
                { text: "Nama", value: "name" },
                { text: "Description", value: "description" },
                { text: "Start At", value: "start_at" },
                { text: "End At", value: "end_at" },
                { text: "Nomor Urut", value: "no_urut" },
            ],
        };
    },

    watch: {
        search() {
            this.fetchData();
        },
    },

    mounted: function () {
        this.fetchData();
    },

    methods: {
        fetchData() {
            this.popUpAds = [];
            var context = this;
            var search = null;
            context.isLoading = true;

            PopUpAdsService.getListPopUpAds((result) => {
                if (result.success) {
                    // this.pagination.totalPages = result.data.total_data;
                    result.data.forEach((items, index) => {
                        var start_time = Moment(items.start_date).format(
                            "YYYY-MM-DD",
                        );
                        var end_time = Moment(items.end_date).format(
                            "YYYY-MM-DD",
                        );
                        var row = {
                            no: index,
                            id: items.id,
                            name: items.name,
                            description: items.description,
                            start_at: start_time,
                            end_at: end_time,
                            no_urut: items.no_urut,
                        };
                        context.popUpAds.push(row);
                    });
                } else {
                    context.$store.commit("showAlert", {
                        message: `Terjadi Kesalahan!`,
                        type: "error",
                    });
                }
                context.isLoading = false;
            });
        },

        createPopUpAds() {
            this.$router.push({ path: "/pop-up-ads/form" });
        },

        editPopUpAds: function () {
            var popUpAdsId = this.selectedRow.id;
            this.$router.push({
                path: "/pop-up-ads/form",
                query: { id: popUpAdsId },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// PopUpAds.vue?5541a506